<template>
  <div class="bg-white rounded-2xl flex flex-col gap-6">
    <div class="flex justify-between items-center">
      <div class="flex items-center gap-3 flex-1 h-10">
        <h2 class="text-gray-900 text-lg font-semibold leading-6">
          {{ title }}
        </h2>

        <div v-if="count !== null" class="w-5 h-10 text-gray-500 text-lg">
          {{ count }}
        </div>
      </div>
    </div>

    <div v-if="showAction">
      <slot name="action"></slot>
    </div>

    <div class="flex flex-col gap-4">
      <SectionGroup
        v-if="type === 'show-service-list'"
        v-for="group in groups"
        :key="group.title"
        :group="group"
        :activeService="activeService"
        :isAccessLoading="isAccessLoading"
        @change:service="changeService"
      />
      <div v-if="selectedService && type === 'show-service-response'">
        <ServiceResponseViewer
          :service="selectedService"
          :is-custom-field="isCustomField"
          :selected-participant-codes="selectedParticipantCodes"
          :default-participant-code="defaultParticipantCode"
          @edit:field="editCustomField"
          @insert="$emit('insert:field', $event)"
        />
      </div>

      <div
        v-if="serviceResponseData && type === 'show-service-response-viewer'"
      >
        <ServiceRuntimeResponseViewer
          :service="selectedService"
          :data="serviceResponseData"
          :schema="selectedService?.response?.properties"
          :is-custom-field="isCustomField"
          :searching="searching"
          :searchCompleted="searchCompleted"
          :selectedParticipant="selectedParticipant"
          @insert="$emit('insert:field', $event)"
          @select:array-item="$emit('select:array-item', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineAsyncComponent } from "vue";
import SectionGroup from "./SectionGroup.vue";
import ServiceResponseViewer from "./ServiceResponseViewer.vue";
const ServiceRuntimeResponseViewer = defineAsyncComponent(() =>
  import("./ServiceRuntimeResponseViewer.vue")
);

const props = defineProps({
  title: { type: String, required: true },
  count: { type: Number, default: null },
  groups: { type: Array, required: true },
  activeService: { type: String, default: null },
  selectedService: { type: Object, default: null },
  serviceResponseData: Object, //  runtime
  searching: {
    type: Boolean,
    default: false,
  },
  searchCompleted: {
    type: Boolean,
    default: true,
  },

  isAccessLoading: {
    type: Boolean,
    default: () => false,
  },

  showAction: { type: Boolean, default: false },
  type: { type: String, default: "show-service-list" },

  selectedParticipant: {
    type: Object,
    default: () => ({}),
  },
  selectedParticipantCodes: {
    type: Array,
    default: () => [],
  },
  defaultParticipantCode: {
    type: String,
    default: null,
  },
});

const emit = defineEmits([
  "change:service",
  "edit:field",
  "insert:field",
  "select:array-item",
]);

const isCustomField = computed(() => {
  return ["all_fields", "favorite_fields"].includes(props.activeService);
});

function changeService(service) {
  emit("change:service", service);
}

function editCustomField(field) {
  emit("edit:field", field);
}
</script>

<style lang="scss" scoped>
.shadow-primary-btn {
  box-shadow: 0px 1px 1px -0.5px rgba(0, 0, 0, 0.03),
    inset 0px 3px 3px rgba(255, 255, 255, 0.12);
}
</style>
